export default {
  state: {
    vats: [],
    loading: false,
  },
  getters: {
    vats: state => state.vats,
    loading: state => state.loading,
  },
  mutations: {
    setVats(state, vats) {
      state.vats = vats;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const vats = await axios.get('api/vats');
        commit('setVats', vats);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/vats/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
        await axios.post('api/vats', payLoad);
    },

    async update({ commit }, payLoad) {
        await axios.put('api/vats', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/vats/' + id);
    }
  },
};
